import {NullableKeys, Options} from '@fl/cmsch-fe-library';

/** Redux-form id for the animal-browser print/export modal. */
export const exportPdfFormName = 'exportPdfForm';

/** Values submitted from the animal-browser print/export modal. */
export interface ExportPdfFormValues {
    breederFemaleDocuments: string;
    bullsDocument: string;
}

/** Default animal-browser print/export form values. */
export const exportPdfInitialValues: NullableKeys<ExportPdfFormValues> = {
    breederFemaleDocuments: 'inseminacni_karta_A4',
    bullsDocument: 'karta_byka',
};

/** Document options available for breeding-female print exports. */
export const breederFemaleDocumentsOptions: Options<string> = [
    {
        value: 'inseminacni_karta_A4',
        label: 'Inseminační karta A4',
    },
    {
        value: 'inseminacni_karta_A5',
        label: 'Inseminační karta A5',
    },
    {
        value: 'inseminacni_karta_A5_pouze_hlavicka',
        label: 'Inseminační karta A5 (pouze hlavička)',
    },
];

/** Document options available for bull print exports. */
export const bullsDocumentOptions: Options<string> = [
    {
        value: 'karta_byka',
        label: 'Karta býka',
    },
];
